import { isSessionExpiredRedirectScheduled } from './sessionExpiredRedirect';

export function getRequestAuthHeader(config) {
  if (!config?.headers) return null;
  const h = config.headers;
  return (
    h.Authorization ??
    h.authorization ??
    (typeof h.get === 'function' ? h.get('Authorization') || h.get('authorization') : null)
  );
}

export function isSessionExpiredApiError(error) {
  return error?.response?.status === 401 && Boolean(getRequestAuthHeader(error?.config));
}

export function shouldSuppressSessionExpiredError(error) {
  if (isSessionExpiredApiError(error)) {
    return true;
  }

  // Client-side expiry redirect may already be in flight before parallel 401s settle.
  return typeof window !== 'undefined' && isSessionExpiredRedirectScheduled();
}

export const getApiErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  if (typeof error?.response?.data === 'string') {
    return error.response.data;
  }

  if (error?.message) {
    return error.message;
  }

  return fallback;
};
